export default __webpack_public_path__ + "static/media/sidebar-uprs_small_no_bg.e3879e52.png";